import * as React from 'react';
import Default from './cards/Default';

const PostsGrid = ({ posts }) => {
    if ( posts.length ) {
        return (
            <div className="pfa-posts-grid">
                {posts.map((post) => {
                    switch (post.post_type) {
                        // TODO: add in custom post types if needed.
                        default: {
                            return <Default post={ post } key={ post.ID } />
                        }
                    }
                })}
            </div>
        )
    }
}

PostsGrid.displayName = 'PostsGrid';

export default PostsGrid;